import React from 'react';
import { useLocation } from 'react-router-dom';
import { isMobileSignInLink } from '../auth/mobileSignInLink';
import TranslationProvider from '../context/Internationalization';
import MobileSignInFallback from '../pages/Login/MobileSignInFallback';

export default function BrowserSignInBoundary({ children }) {
  const { search } = useLocation();
  // Stay outside AuthProvider: restoring an existing Firebase session must not
  // bootstrap/register a Core identity while handling an emailed Mobile link.
  if (isMobileSignInLink(search)) {
    const actionLanguage = new URLSearchParams(search).get('lang');
    // Firebase uses "el" for Greek; console's translation key is "gr".
    // The provider gives an existing saved preference priority over this hint.
    const initialLanguage = actionLanguage === 'el' ? 'gr' : actionLanguage;
    return <TranslationProvider initialLanguage={initialLanguage}>
      <MobileSignInFallback />
    </TranslationProvider>;
  }
  return children;
}
